import qs from 'qs';

export const popUp = () => {
  const query = qs.stringify({
    populate: ['backgroundImage', 'decorationImage'],
  });
  return '/popup?' + query;
};
